/*
  Shreya theme — quick view.
  Clicking any [data-quick-view="<product url>"] opens #quick-view-drawer and loads
  <url>?section_id=quick-view-product into it. Product assets are fetched on first use.
*/
(() => {
  const DRAWER_ID = 'quick-view-drawer';
  let assets = null;
  let request = 0;
  let clearTimer = null;

  const loadStyle = (href) => new Promise((resolve) => {
    if (!href || Array.from(document.styleSheets).some((s) => s.href && s.href.split('?')[0] === new URL(href, location.href).href.split('?')[0])) return resolve();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = link.onerror = () => resolve();
    document.head.appendChild(link);
  });

  const loadScript = (src) => new Promise((resolve) => {
    if (!src || (window.Theme && Theme.productReady)) return resolve();
    const existing = Array.from(document.scripts).find((s) => s.src && s.src.split('?')[0] === new URL(src, location.href).href.split('?')[0]);
    if (existing) {
      // already on the page (product template) — it may still be waiting to run
      if (window.Theme && Theme.productReady) return resolve();
      existing.addEventListener('load', () => resolve(), { once: true });
      setTimeout(resolve, 1500);
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = script.onerror = () => resolve();
    document.head.appendChild(script);
  });

  const ensureAssets = (drawer) => {
    if (!assets) assets = Promise.all([loadStyle(drawer.dataset.css), loadScript(drawer.dataset.js)]);
    return assets;
  };

  const open = async (url, trigger) => {
    const drawer = document.getElementById(DRAWER_ID);
    const body = drawer && drawer.querySelector('[data-quick-view-body]');
    if (!drawer || !body) { window.location.href = url; return; }

    clearTimeout(clearTimer);
    const ticket = ++request;
    const loading = drawer.querySelector('template[data-quick-view-loading]');
    body.innerHTML = loading ? loading.innerHTML : '';
    body.setAttribute('aria-busy', 'true');
    Theme.openDrawer(DRAWER_ID, trigger);

    try {
      const [html] = await Promise.all([Theme.fetchSection('quick-view-product', url), ensureAssets(drawer)]);
      if (ticket !== request) return;
      const content = Theme.parseHTML(html).querySelector('[data-quick-view-product]');
      if (!content) throw new Error('missing');
      body.innerHTML = content.outerHTML;
      body.removeAttribute('aria-busy');
      Theme.init(body);
      const title = body.querySelector('.pb-title a');
      if (title) title.focus({ preventScroll: true });
    } catch (_) {
      if (ticket === request) window.location.href = url;
    }
  };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger || !trigger.dataset.quickView || !document.getElementById(DRAWER_ID)) return;
    e.preventDefault();
    open(trigger.dataset.quickView, trigger);
  });

  // Empty the drawer after it closes so videos stop and ids never clash with the page.
  document.addEventListener('drawer:close', (e) => {
    if (!e.target || e.target.id !== DRAWER_ID) return;
    const body = e.target.querySelector('[data-quick-view-body]');
    clearTimer = setTimeout(() => { if (body) body.innerHTML = ''; }, 600);
  });
})();
